module.exports = __webpack_public_path__ + "img/serve.a23e6e46.png";